/* NORLAYA v4 — bundelkiezer met maatkeuze per stuk */
(function () {
  'use strict';
  var doc = document;

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') > -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, v)
                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                   .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
                   .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
    }
    return '£' + v;
  }

  function openCart() {
    var d = doc.querySelector('cart-drawer, #cart-drawer, .drawer--cart');
    if (d && typeof d.open === 'function') { d.open(); return true; }
    if (d && typeof d.show === 'function') { d.show(); return true; }
    return false;
  }

  function init() {
    var wrap = doc.querySelector('[data-lh-bundle]');
    if (!wrap || wrap.dataset.lhReady) return;

    var form = doc.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form) return;
    wrap.dataset.lhReady = '1';

    var fmt = wrap.getAttribute('data-money-format') || '';
    var raw = doc.querySelector('script[data-lh-variants]');
    var variants = [];
    try { variants = JSON.parse(raw ? raw.textContent : '[]'); } catch (e) {}
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    var idField = form.querySelector('input[name="id"], select[name="id"]');
    var qtyField = form.querySelector('input[name="quantity"]');

    function currentVariantId() {
      return idField && idField.value ? String(idField.value) : (variants[0] ? String(variants[0].id) : '');
    }

    function selectedQty() {
      var r = wrap.querySelector('input[name="lh-bundle"]:checked');
      return r ? parseInt(r.value, 10) : 1;
    }

    /* welke varianten zitten er in de gekozen bundel */
    function piecesFor(n) {
      if (n === 1) return [currentVariantId()];
      var sel = wrap.querySelectorAll('[data-lh-piece="' + n + '"]');
      if (!sel.length) {
        var out = [];
        for (var i = 0; i < n; i++) out.push(currentVariantId());
        return out;
      }
      return Array.prototype.map.call(sel, function (s) { return s.value; });
    }

    /* prijzen van alle drie de opties opnieuw berekenen */
    function refresh() {
      [1, 2, 3].forEach(function (n) {
        var opt = wrap.querySelector('[data-lh-opt="' + n + '"]');
        if (!opt) return;
        var pct = n === 3 ? 80 : (n === 2 ? 90 : 100);
        var gross = piecesFor(n).reduce(function (sum, id) {
          var v = byId[String(id)];
          return sum + (v ? v.price : 0);
        }, 0);
        var net = Math.round(gross * pct / 100);
        var was = opt.querySelector('[data-lh-was]');
        var now = opt.querySelector('[data-lh-now]');
        var each = opt.querySelector('[data-lh-each]');
        if (was) was.textContent = money(gross, fmt);
        if (now) now.textContent = money(net, fmt);
        if (each) each.textContent = money(Math.round(net / n), fmt) + ' per piece';
      });
    }

    /* maatkeuzes tonen/verbergen en het aantalveld bijwerken */
    function applySelection() {
      var n = selectedQty();
      wrap.querySelectorAll('.lh-bundle__opt').forEach(function (o) {
        o.classList.toggle('is-active', o.getAttribute('data-lh-opt') === String(n));
      });
      wrap.querySelectorAll('[data-lh-sizes]').forEach(function (box) {
        box.hidden = box.getAttribute('data-lh-sizes') !== String(n);
      });
      if (qtyField) {
        /* bij meerdere maten voegen we zelf toe, dan blijft het aantal 1 */
        qtyField.value = (n > 1 && wrap.querySelector('[data-lh-piece]')) ? 1 : n;
        qtyField.dispatchEvent(new Event('change', { bubbles: true }));
      }
      refresh();
    }

    wrap.addEventListener('change', function (e) {
      if (e.target.closest('input[name="lh-bundle"]')) { applySelection(); return; }
      if (e.target.closest('[data-lh-piece]')) { refresh(); }
    });

    /* eerste maatkeuze volgt de variantkiezer van het thema */
    var lastId = currentVariantId();
    setInterval(function () {
      var id = currentVariantId();
      if (id === lastId) return;
      lastId = id;
      wrap.querySelectorAll('[data-lh-piece]').forEach(function (s, i) {
        var n = parseInt(s.getAttribute('data-lh-piece'), 10);
        var first = wrap.querySelector('[data-lh-piece="' + n + '"]');
        if (s === first) s.value = id;
      });
      refresh();
    }, 300);

    /* toevoegen: bij een bundel met verschillende maten zelf posten */
    form.addEventListener('submit', function (e) {
      var n = selectedQty();
      if (n < 2 || !wrap.querySelector('[data-lh-piece]')) return;

      e.preventDefault();
      e.stopPropagation();

      var counts = {};
      piecesFor(n).forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) {
        return { id: Number(id), quantity: counts[id] };
      });

      var btn = form.querySelector('[type="submit"], [name="add"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          doc.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          if (!openCart()) window.location.href = '/cart';
        })
        .catch(function (err) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          console.error('bundle:', err);
        });
    }, true);

    applySelection();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
  doc.addEventListener('shopify:section:load', init);
})();

/* NORLAYA v4 — kruisverkoop: toevoegen zonder de pagina te verliezen */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-nh-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  var id = btn.getAttribute('data-nh-add');
  var label = btn.innerHTML;
  btn.disabled = true; btn.textContent = 'Adding…';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
  })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
    .then(function () {
      btn.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (location.pathname.indexOf('/cart') === 0) {
        setTimeout(function () { location.reload(); }, 500);
        return;
      }
      setTimeout(function () {
        btn.disabled = false; btn.innerHTML = label;
        var d = document.querySelector('cart-drawer, #cart-drawer');
        if (d && typeof d.open === 'function') d.open();
        else if (d && typeof d.show === 'function') d.show();
      }, 700);
    })
    .catch(function () {
      btn.textContent = 'Unavailable';
      setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 1600);
    });
});
